/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Fragment, FC, ReactNode, useState } from 'react';
import { Headline, Body } from '@airwallex/typography';
import { space } from '@airwallex/global';

import { useMobile } from '@/hooks/useMediaQuery';
import Header from '@/components/header';

import { TopBox, ImageWrapper, Content } from './style';

interface ErrorWithLogoProps {
  logoUrl?: string;
  image?: JSX.Element;
  title?: ReactNode;
  body?: ReactNode;
}

const ErrorWithLogo: FC<ErrorWithLogoProps> = ({ logoUrl, image, title, body }) => {
  const isMobile = useMobile();
  const [imgError, setImgError] = useState(false);

  return (
    <Fragment>
      <Header isMobile={isMobile} haveLanguageChoice hideBorder={!isMobile} />
      <TopBox
        css={css`
          margin-top: ${space.l};
        `}
      >
        <ImageWrapper>{image}</ImageWrapper>
      </TopBox>
      <Content>
        <Headline
          css={css`
            margin-top: ${space.xxxl};
          `}
        >
          {title}
        </Headline>
        <Body
          variant="100"
          css={css`
            margin-top: ${space.s};
          `}
        >
          {body}
        </Body>
        {logoUrl && !imgError && (
          <img
            onError={() => setImgError(true)}
            css={css`
              height: 32px;
              margin-top: ${space.xl};
            `}
            src={logoUrl}
            alt="logo"
          />
        )}
      </Content>
    </Fragment>
  );
};

export default ErrorWithLogo;
